// Map German zip code ranges to federal states (Bundesländer)
export const getRegionFromZipCode = (zipCode: string): string => {
  const zip = parseInt(zipCode, 10);

  if (isNaN(zip)) return "";

  // Zip code ranges for German federal states
  if (zip >= 1000 && zip <= 1999) return "Brandenburg";
  if (zip >= 2000 && zip <= 2999) return "Hamburg";
  if (zip >= 3000 && zip <= 3999) return "Niedersachsen";
  if (zip >= 4000 && zip <= 4999) return "Nordrhein-Westfalen";
  if (zip >= 5000 && zip <= 5999) return "Nordrhein-Westfalen";
  if (zip >= 6000 && zip <= 6999) return "Hessen";
  if (zip >= 7000 && zip <= 7999) return "Rheinland-Pfalz";
  if (zip >= 8000 && zip <= 8999) return "Baden-Württemberg";
  if (zip >= 9000 && zip <= 9999) return "Bayern";
  if (zip >= 10000 && zip <= 14999) return "Berlin";
  if (zip >= 15000 && zip <= 19999) return "Brandenburg";
  if (zip >= 20000 && zip <= 21999) return "Hamburg";
  if (zip >= 22000 && zip <= 27999) return "Schleswig-Holstein";
  if (zip >= 28000 && zip <= 28999) return "Bremen";
  if (zip >= 29000 && zip <= 29999) return "Niedersachsen";
  if (zip >= 30000 && zip <= 31999) return "Niedersachsen";
  if (zip >= 32000 && zip <= 33999) return "Nordrhein-Westfalen";
  if (zip >= 34000 && zip <= 34999) return "Hessen";
  if (zip >= 35000 && zip <= 36999) return "Hessen";
  if (zip >= 37000 && zip <= 37999) return "Niedersachsen";
  if (zip >= 38000 && zip <= 38999) return "Niedersachsen";
  if (zip >= 39000 && zip <= 39999) return "Sachsen-Anhalt";
  if (zip >= 40000 && zip <= 48999) return "Nordrhein-Westfalen";
  if (zip >= 49000 && zip <= 49999) return "Niedersachsen";
  if (zip >= 50000 && zip <= 53999) return "Nordrhein-Westfalen";
  if (zip >= 54000 && zip <= 56999) return "Rheinland-Pfalz";
  if (zip >= 57000 && zip <= 57999) return "Nordrhein-Westfalen";
  if (zip >= 58000 && zip <= 59999) return "Nordrhein-Westfalen";
  if (zip >= 60000 && zip <= 63999) return "Hessen";
  if (zip >= 64000 && zip <= 65999) return "Hessen";
  if (zip >= 66000 && zip <= 66999) return "Saarland";
  if (zip >= 67000 && zip <= 67999) return "Rheinland-Pfalz";
  if (zip >= 68000 && zip <= 68999) return "Baden-Württemberg";
  if (zip >= 69000 && zip <= 69999) return "Baden-Württemberg";
  if (zip >= 70000 && zip <= 76999) return "Baden-Württemberg";
  if (zip >= 77000 && zip <= 79999) return "Baden-Württemberg";
  if (zip >= 80000 && zip <= 87999) return "Bayern";
  if (zip >= 88000 && zip <= 89999) return "Baden-Württemberg";
  if (zip >= 90000 && zip <= 96999) return "Bayern";
  if (zip >= 97000 && zip <= 97999) return "Bayern";
  if (zip >= 98000 && zip <= 99999) return "Thüringen";

  return "";
};

export const germanStates = [
  "Baden-Württemberg",
  "Bayern",
  "Berlin",
  "Brandenburg",
  "Bremen",
  "Hamburg",
  "Hessen",
  "Mecklenburg-Vorpommern",
  "Niedersachsen",
  "Nordrhein-Westfalen",
  "Rheinland-Pfalz",
  "Saarland",
  "Sachsen",
  "Sachsen-Anhalt",
  "Schleswig-Holstein",
  "Thüringen",
];
